import { ThemeEvents } from '@theme/events';

/**
 * Displays the SKU of the currently selected variant.
 * Mirrors the approach used by product-price.js: when a variant update event
 * fires, the freshly rendered section HTML is handed to us, so we swap in the
 * matching <c-product-sku> contents.
 */
class ProductSku extends HTMLElement {
  connectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.addEventListener(ThemeEvents.variantUpdate, this.updateSku);
  }

  disconnectedCallback() {
    const closestSection = this.closest('.shopify-section, dialog');
    if (!closestSection) return;
    closestSection.removeEventListener(ThemeEvents.variantUpdate, this.updateSku);
  }

  updateSku = (event) => {
    const detail = event.detail;
    if (!detail || !detail.data || !detail.data.html) return;

    if (detail.data.newProduct) {
      this.dataset.productId = detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const next = detail.data.html.querySelector('c-product-sku');
    if (!next) return;

    if (this.innerHTML !== next.innerHTML) {
      this.innerHTML = next.innerHTML;
    }
  };
}

if (!customElements.get('c-product-sku')) {
  customElements.define('c-product-sku', ProductSku);
}
